module.exports = __webpack_public_path__ + "static/media/star-two.38380f59.svg";